import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import SortIcon from "../../../global/components/SortIcon";
import { Tooltip } from "antd";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { render } from "@testing-library/react";
export const ProxyColumns = (
  hoveredRow,
  setShowModal,
  setSelectedRowKeys,
  setParams,
  params
) => {
  const modParams = { ...Object.fromEntries([...params?.entries()]) } || {}; //
  const ProxyTypeOptions = [
    { label: "On Premise", value: 0 },
    { label: "Cloud Site", value: 1 },
  ];
  return [
    // {
    //   title: "No",
    //   dataIndex: "ProxyNo",
    //   key: "ProxyNo",
    //   sorter: (a, b) => a?.ProxyNo - b?.ProxyNo,
    //   sortIcon: () => (
    //     <SortIcon
    //       sortOrder={params.order}
    //       columnKey="ProxyNo"
    //       sortBy={params.sort_by}
    //     />
    //   ),
    //   onHeaderCell: () => ({
    //     onClick: () =>
    //       setParams((prev) => ({
    //         ...prev,
    //         sort_by: "ProxyNo",
    //         order: prev.order === "desc" ? "asc" : "desc",
    //       })),
    //   }),
    // },
    {
      title: "Proxy Address",
      dataIndex: "ProxyAddr",
      key: "ProxyAddr",
      sorter: (a, b) => () => {},
      sortIcon: () => (
        <SortIcon
          sortOrder={modParams.order}
          columnKey="ProxyAddr"
          sortBy={modParams.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...modParams,
            sort_by: "ProxyAddr",
            order: modParams.order === "desc" ? "asc" : "desc",
          })),
      }),
    },
    {
      title: "IP Address",
      dataIndex: "Address",
      key: "Address",
      sorter: (a, b) => () => {},
      sortIcon: () => (
        <SortIcon
          sortOrder={modParams.order}
          columnKey="Address"
          sortBy={modParams.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...modParams,
            sort_by: "Address",
            order: modParams.order === "desc" ? "asc" : "desc",
          })),
      }),
    },
    {
      title: "Proxy Port",
      dataIndex: "ProxyPort",
      key: "ProxyPort",
      sorter: (a, b) => () => {},
      sortIcon: () => (
        <SortIcon
          sortOrder={modParams.order}
          columnKey="ProxyPort"
          sortBy={modParams.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...modParams,
            sort_by: "ProxyPort",
            order: modParams.order === "desc" ? "asc" : "desc",
          })),
      }),
    },

    {
      title: "Proxy Type",
      dataIndex: "ProxyType",
      key: "ProxyType",
      sorter: (a, b) => () => {},
      sortIcon: () => (
        <SortIcon
          sortOrder={modParams.order}
          columnKey="ProxyType"
          sortBy={modParams.sort_by}
        />
      ),
      render: (text, record) => {
        if (text !== null) {
          return ProxyTypeOptions.find((item) => item.value === text)?.label;
        }
      },
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...modParams,
            sort_by: "ProxyType",
            order: modParams.order === "desc" ? "asc" : "desc",
          })),
      }),
    },
    {
      title: "Site Count",
      dataIndex: "sites_count",
      key: "sites_count",
      sorter: (a, b) => () => {},
      sortIcon: () => (
        <SortIcon
          sortOrder={modParams.order}
          columnKey="sites_count"
          sortBy={modParams.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...modParams,
            sort_by: "sites_count",
            order: modParams.order === "desc" ? "asc" : "desc",
          })),
      }),
    },
    // {
    //   title: "Online Count",
    //   dataIndex: "online_sites_count",
    //   key: "online_sites_count",
    //   sorter: (a, b) => () => {},
    //   sortIcon: () => (
    //     <SortIcon
    //       sortOrder={modParams.order}
    //       columnKey="online_sites_count"
    //       sortBy={modParams.sort_by}
    //     />
    //   ),
    //   onHeaderCell: () => ({
    //     onClick: () =>
    //       setParams((prev) => ({
    //         ...modParams,
    //         sort_by: "online_sites_count",
    //         order: modParams.order === "desc" ? "asc" : "desc",
    //       })),
    //   }),
    // },
    {
      title: "Node Count",
      dataIndex: "node_count",
      key: "node_count",
      sorter: (a, b) => () => {},
      sortIcon: () => (
        <SortIcon
          sortOrder={modParams.order}
          columnKey="node_count"
          sortBy={modParams.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...modParams,
            sort_by: "node_count",
            order: modParams.order === "desc" ? "asc" : "desc",
          })),
      }),
    },
    // {
    //   title: "Site Type",
    //   dataIndex: "SiteTypeName",
    //   key: "SiteTypeName",
    //   sorter: (a, b) => () => {},
    //   sortIcon: () => (
    //     <SortIcon
    //       sortOrder={modParams.order}
    //       columnKey="SiteTypeName"
    //       sortBy={modParams.sort_by}
    //     />
    //   ),
    //   onHeaderCell: () => ({
    //     onClick: () =>
    //       setParams((prev) => ({
    //         ...modParams,
    //         sort_by: "SiteTypeName",
    //         order: modParams.order === "desc" ? "asc" : "desc",
    //       })),
    //   }),
    // },
    {
      title: "",
      fixed: "right",
      width: 0,
      align: "center",
      render: (text, record, rowIndex) =>
        hoveredRow === rowIndex ? (
          <div className="absolute top-2 right-5">
            <div className="bg-[#EFF0F2] duration-75 bottom-0 flex gap-2 items-center justify-center z-50">
              <Tooltip title="Edit">
                <div className="hover:bg-gray-400 px-[5px] py-1 rounded-[4px] mr-1 ">
                  <Link
                    to={`/proxyserver/edit/${record?.ProxyNo}`}
                    onClick={(e) => e.stopPropagation()}
                    className=" hover:text-[#636262ee]"
                  >
                    <FontAwesomeIcon
                      icon={faEdit}
                      className="!text-[#50565e]"
                    />
                  </Link>
                </div>
              </Tooltip>
              <Tooltip title="Delete">
                <div
                  onClick={(e) => {
                    e.stopPropagation();
                    setShowModal(true);
                    setSelectedRowKeys([record?.ProxyNo]);
                  }}
                  className="cursor-pointer hover:bg-gray-400 px-1 py-1 rounded-[4px] "
                >
                  <DeleteOutlined />
                </div>
              </Tooltip>
            </div>
          </div>
        ) : null,
    },
  ];
};
